/* ============================================
   NAOKO — Press slider („W mediach")
   Desktop: strzałki. Mobile: kropki + swipe.
   File: assets/naoko-press-slider.js
   ============================================ */
(function () {
  function init(root) {
    if (!root || root.dataset.pressInit === '1') return;
    var track = root.querySelector('.naoko-press-slider__track');
    if (!track) return;
    root.dataset.pressInit = '1';

    var slides = Array.prototype.slice.call(track.children);
    var dots = root.querySelector('.naoko-press-slider__dots');
    var prev = root.querySelector('.naoko-press-slider__arrow--prev');
    var next = root.querySelector('.naoko-press-slider__arrow--next');

    if (slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dots) dots.style.display = 'none';
      return;
    }

    var idx = 0;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    if (dots) {
      dots.innerHTML = '';
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'naoko-press-slider__dot';
        b.setAttribute('aria-label', 'Przejdź do slajdu ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });
    }
    var dotEls = dots ? Array.prototype.slice.call(dots.children) : [];

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            idx = slides.indexOf(e.target);
            dotEls.forEach(function (d, di) {
              d.setAttribute('aria-current', di === idx ? 'true' : 'false');
            });
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  function initAll() {
    document.querySelectorAll('.naoko-press-slider').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector && e.target.querySelector('.naoko-press-slider');
    if (el) {
      el.dataset.pressInit = '';
      init(el);
    }
  });
})();
